var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriverTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 27 26",
    fill: "none",
    focusable: "false",
    "aria-hidden": "true",
    "data-testid": "TruckOutlinedIcon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.61841 5.49463H1.54613C1.30424 5.49463 1.10815 5.64112 1.10815 5.82183V7.4268C1.10815 7.60751 1.30424 7.754 1.54613 7.754H2.61841C2.8603 7.754 3.05639 7.60751 3.05639 7.4268V5.82183C3.05639 5.64112 2.8603 5.49463 2.61841 5.49463Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.3895 8.48729L3.05615 7.75391",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.8935 5.49463H24.9658C25.2077 5.49463 25.4038 5.64112 25.4038 5.82183V7.4268C25.4038 7.60751 25.2077 7.754 24.9658 7.754H23.8935C23.6517 7.754 23.4556 7.60751 23.4556 7.4268V5.82183C23.4556 5.64112 23.6517 5.49463 23.8935 5.49463Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.1227 8.48729L23.4561 7.75391",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.425 11.4091H18.3655C18.5639 11.4091 18.7232 11.2591 18.7232 11.0771V7.14788C18.7232 6.96275 18.5639 6.81592 18.3655 6.81592H8.10506C7.94299 6.81592 7.81445 6.96594 7.81445 7.14788V11.0771C7.81445 11.2622 7.94578 11.4091 8.10506 11.4091H12.9587",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.6892 19.4471H9.84885C9.675 19.4471 9.53711 19.3202 9.53711 19.1641V14.5627C9.53711 14.4067 9.67799 14.2798 9.84885 14.2798H16.6892C16.8631 14.2798 17.001 14.4067 17.001 14.5627V19.1641C17.001 19.3202 16.8601 19.4471 16.6892 19.4471Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.3167 16.4477C23.2366 14.9555 22.0767 14.7225 21.5212 14.694C21.3636 14.6855 21.2434 14.5548 21.2434 14.4013L21.1861 1.94355C21.1861 1.72754 20.957 1.58542 20.7594 1.67638L19.0927 2.44948C18.9867 2.4978 18.9209 2.60296 18.9209 2.7195V4.02979C18.9209 4.29412 18.6001 4.42771 18.4111 4.24012L17.6493 3.48407C17.5949 3.43007 17.5176 3.3988 17.4403 3.39596L13.159 3.36754H13.4196L9.13822 3.39596C9.0609 3.39596 8.98358 3.42723 8.92917 3.48407L8.16741 4.24012C7.9784 4.42771 7.65766 4.29412 7.65766 4.02979V2.7195C7.65766 2.60296 7.59179 2.50064 7.48583 2.44948L5.81912 1.67638C5.62152 1.58542 5.39528 1.72754 5.39242 1.94355L5.33514 14.4013C5.33514 14.5576 5.21486 14.6884 5.05735 14.694C4.50465 14.7225 3.30187 14.9555 3.22168 16.4477V22.115C3.22168 22.1825 3.30335 22.3176 3.63002 22.3176C3.95669 22.3176 8.53012 22.3176 10.776 22.3176H13.6344C16.5608 22.3176 22.4954 22.3176 22.8221 22.3176C23.1488 22.3176 23.288 22.1825 23.3167 22.115V16.4477Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.0061 16.8389H9.57959",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M8.00743 22.3179H5.30467C5.14261 22.3179 5.01123 22.4492 5.01123 22.6113V24.0579C5.01123 24.22 5.14261 24.3514 5.30467 24.3514H8.00743C8.16949 24.3514 8.30087 24.22 8.30087 24.0579V22.6113C8.30087 22.4492 8.16949 22.3179 8.00743 22.3179Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M21.1656 22.3179H18.4629C18.3008 22.3179 18.1694 22.4492 18.1694 22.6113V24.0579C18.1694 24.22 18.3008 24.3514 18.4629 24.3514H21.1656C21.3277 24.3514 21.4591 24.22 21.4591 24.0579V22.6113C21.4591 22.4492 21.3277 22.3179 21.1656 22.3179Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 169"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 61",
    cx: 6.41946,
    cy: 17.8648,
    r: 1.08108,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 170"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 61_2",
    cx: 19.9326,
    cy: 17.8648,
    r: 1.08108,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverTruck);
export default __webpack_public_path__ + "static/media/driver-truck.34ce1e2efd9e5e9999188c2912cc632f.svg";
export { ForwardRef as ReactComponent };